/* Snackbar */
export const SET_SNACKBAR_TIMEOUT = 'SET_SNACKBAR_TIMEOUT'
export const SET_SNACKBAR_TEXT = 'SET_SNACKBAR_TEXT'
export const SET_SNACKBAR_OPEN = 'SET_SNACKBAR_OPEN'
